import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../../shared/shared/shared.module';
import { CountryCodeService } from '../../../services/country-code/country-code.service';
import { GeneratedTextDestinationSearchComponent } from './destination-search/generated-text-destination-search.component';
import { GeneratedTextDestinationInfoComponent } from './destination-info/generated-text-destination-info.component';
import { GeneratedTextDestinationAddModalComponent } from './destination-add-modal/generated-text-destination-add-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  providers: [
    CountryCodeService,
  ],
  declarations: [
    GeneratedTextDestinationSearchComponent,
    GeneratedTextDestinationInfoComponent,
    GeneratedTextDestinationAddModalComponent,
  ]
})
export class GeneratedTextDestinationModule {
}
